import { createAction, props } from '@ngrx/store';
import { NoParkingZone } from '../../../modules/no-parking-zones/interfaces';

// create no parking zone
export const CREATE_NO_PARKING_ZONE = '[No Parking Zones] Create No Parking Zone';

export const CreateNoParkingZone = createAction(CREATE_NO_PARKING_ZONE, props<{ payload: NoParkingZone }>());

// edit no parking zones
export const EDIT_NO_PARKING_ZONE = '[No Parking Zones] Update No Parking Zone';

export const EditNoParkingZone = createAction(EDIT_NO_PARKING_ZONE, props<{ payload: NoParkingZone }>());

// delete no parking zones
export const DELETE_NO_PARKING_ZONE = '[No Parking Zones] Delete No Parking Zone';

export const DeleteNoParkingZone = createAction(DELETE_NO_PARKING_ZONE, props<{ payload: string }>());

// upload no parking zones
export const UPLOAD_NO_PARKING_ZONES = '[No Parking Zones] Upload No Parking Zones';

export const UploadNoParkingZones = createAction(UPLOAD_NO_PARKING_ZONES, props<{ payload: NoParkingZone[] }>());

// action types
export type NoParkingZonesAction =
    | typeof CreateNoParkingZone
    | typeof EditNoParkingZone
    | typeof DeleteNoParkingZone
    | typeof UploadNoParkingZones;
